import { ApplicationRef, inject, Injectable, isDevMode } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { AmplitudeService } from "@dcc/shared/amplitude";
import { concat, first, interval } from "rxjs";
import { pwaInstalled } from "./amplitude-events";

@Injectable()
export class SwUpdateService {
    private amplitude = inject(AmplitudeService);
    private appRef = inject(ApplicationRef);
    private swUpdate = inject(SwUpdate);

    init(): void {
        this.trackAppInstalls();
        this.checkForUpdates();
    }

    private checkForUpdates(): void {
        // Allow the app to stabilize first, before starting
        // polling for updates with `interval()`.
        const appIsStable$ = this.appRef.isStable.pipe(first((isStable) => isStable === true));
        const everyFiveMinutesHours$ = interval(5 * 60 * 1000);
        const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everyFiveMinutesHours$);
        everySixHoursOnceAppIsStable$.subscribe(async () => {
            try {
                const updateFound = await this.swUpdate.checkForUpdate();
                if (isDevMode()) {
                    console.log(updateFound ? "A new version is available." : "Already on the latest version.");
                }
            } catch (err) {
                console.error("Failed to check for updates:", err);
            }
        });
    }

    private trackAppInstalls(): void {
        window.addEventListener("appinstalled", () => {
            this.amplitude.trackEvent(pwaInstalled());
        });
    }
}
